import { Icon } from '@kpa/kul';
import { FC, ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { NyhetsBlockResponse } from '../../types/blocks';
import { NyhetResponse, NyhetsarkivResponse } from '../../types/pages';
import styles from './Nyhet.module.css';
import NyhetContent from './NyhetContent';

export type Nyheter = NyhetsarkivResponse | NyhetsBlockResponse;

type NyhetProps = {
  nyhet: NyhetResponse;
};

const Nyhet: FC<NyhetProps> = ({ nyhet }): ReactNode => {
  const nav = useNavigate();

  const redirect = (e: React.MouseEvent<HTMLAnchorElement | MouseEvent>, url: string) => {
    e.preventDefault();
    nav(url);
  };

  const GetLinkRad = () => {
    return (
      <a href={nyhet.url} className={`${styles.container} ${styles.link}`} onClick={e => redirect(e, nyhet.url)} rel="noopener noreferrer">
        <NyhetContent nyhet={nyhet}></NyhetContent>
        <Icon name="IconCaretRight" className={styles.iconarrow} color="link" size="medium"></Icon>
      </a>
    );
  };

  const GetNotisRad = () => {
    return (
      <div className={styles.container}>
        <NyhetContent nyhet={nyhet}></NyhetContent>
      </div>
    );
  };

  return nyhet.notis
    ? GetNotisRad()
    : GetLinkRad();
};

export default Nyhet;
